import QuanLiTaiSanPage from 'components/quan-li-tai-san/QuanLiTaiSanPage';
import { ASSET_SOURCE } from 'config/constants/assetConstant';
import React from 'react';

function CongDoanQuanLiTaiSanPage() {
    return <QuanLiTaiSanPage assetSource={ASSET_SOURCE.CONGDOAN}></QuanLiTaiSanPage>;
}

export default CongDoanQuanLiTaiSanPage;
